<script>
import baseList from "@/views/components/base/baseList.vue";
import dayjs from "dayjs";
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "monitoringData",
        key: "id",
        url: {
          list: "admin/statistics/getSysConsumableInventoryStatistics",
        },
        output: false,
      },
      actions: [
        // {
        //   label: "新增",
        //   icon: "md-add",
        //   onClick: this.toAdd,
        //   type: "info",
        //   auth: "system/deviceClass/add",
        // },
      ],
      query: {
        begin: dayjs().startOf("month").format("YYYY-MM-DD"),
        end: dayjs().format("YYYY-MM-DD"),
      },
      menus: [],
      filters: [
        {
          label: "型号/品牌",
          KeyEnter: this.search,
          name: "searchValue",
          value: "",
          type: "input",
        },
        {
          label: "日期",
          KeyEnter: this.search,
          name: "repairTime",
          value: [
            dayjs().startOf("month").format("YYYY-MM-DD"),
            dayjs().format("YYYY-MM-DD"),
          ],
          type: "datetimerange",
        },
      ],
      tableCols: [
        {
          type: "index",
          title: "序号",
          width: 70,
          align: "center",
        },
        {
          title: "物资型号/品牌",
          key: "facilityName",
          minWidth: 200,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            return (
              <span>
                {row.model}/{row.brand}
              </span>
            );
          },
        },
        {
          title: "入库数",
          key: "bhCount",
          minWidth: 120,
          align: "center",
        },
        {
          title: "出库（领用）数",
          minWidth: 150,
          align: "center",
          key: "commonCount",
          render: (h, params) => {
            const row = params.row;
            const text = row.commonCount;
            return <span>{text}</span>;
          },
        },
        {
          title: "库存数",
          minWidth: 120,
          align: "center",
          key: "num",
        },
        {
          title: "异常数",
          minWidth: 120,
          align: "center",
          key: "abnormalCount",
        },
        // {
        //   title: "操作",
        //   align: "center",
        //   width: 150,
        //   key: "handle",
        //   fixed: "right",
        //   handle: ["edit", "delete"],
        //   auth: {
        //     edit: "system/deviceClass/edit",
        //     del: "system/deviceClass/delete",
        //   },
        // },
      ],
    };
  },
  created() {},
  methods: {},
};
</script>
<style scoped></style>
